<template lang="html">
  <div class="page-content">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'page-content'
};
</script>


// WEBPACK FOOTER //
// page-content.vue?fd4e8236